import LazyLoad from 'react-lazyload';
import { convertPrice } from '../../../Utils/ForeignUtils';
import { useScrolltoWidgetSetter } from '../../../Utils/productPageUtils';
import { useRef } from 'react';

export default function TrustTypeMerge(props) {
  const { trustStripClickHandler, fireEventHandler, policyData } = props;
  const { scrollToWidget } = useScrolltoWidgetSetter();
  const { price: delivPrice, symbol } = convertPrice(499);
  const returnRef = useRef();
  const payRef = useRef();
  const freeShipRef = useRef();
  return (
    <>
      <div
        ref={returnRef}
        onClick={(e) => {
          returnRef.current.style.opacity = 0.4;
          setTimeout(() => {
            returnRef.current.style.opacity = 1;
          }, 800);
          scrollToWidget(`div[data-policy-widget=${true}]`);
          fireEventHandler();
        }}
        className="returnRefund"
        data-type="returnrefund"
      >
        <LazyLoad once offset={100}>
          <img src="/images/15dayseasyblack.svg" alt="" />
        </LazyLoad>

        <p data-type="returnrefund">{policyData?.policyName}</p>
      </div>
      <div
        ref={payRef}
        onClick={() => {
          trustStripClickHandler(payRef);
        }}
        className="returnRefund"
      >
        <LazyLoad once offset={100}>
          <img src="/images/deliveryblack.svg" alt="" />
        </LazyLoad>
        <p>Pay Cash on Delivery</p>
      </div>
      <div
        ref={freeShipRef}
        onClick={() => {
          trustStripClickHandler(freeShipRef);
        }}
        className="returnRefund"
      >
        <LazyLoad once offset={100}>
          <img src="/images/freedeliveryblack.svg" alt="" />
        </LazyLoad>
        <p>
          FREE Delivery above {symbol}
          {delivPrice}
        </p>
      </div>
    </>
  );
}
